/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { api } from "api";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import CompetencyAndInterviewResult from "./CompetencyAndInterviewResult";
import Pagination from "react-js-pagination";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import { Trans } from "react-i18next";
import i18next from "i18next";
import Helpers from "util/helpers";

class CompetencyAndInterviewResults extends Component {
  state = {
    results: [],
    filteredData: [],
    filterTerm: "",
    error: null,
    activePage: 1,
    sort_by: "trDocument",
    sort_dir: "desc",
  };

  settings = {
    itemsPerPage: 10,
  };

  componentDidMount() {
    this.getCompetencyAndInterviewResults();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.filterTerm !== prevState.filterTerm) {
      this.setState({
        filteredData: this.state.results.filter((item) => {
          return (
            Helpers.getTurkishCharaterFixedList(item.document.name).includes(
              Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
            ) ||
            Helpers.getTurkishCharaterFixedList(item.position.name).includes(
              Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
            )
          );
        }),
        activePage: 1,
      });
    }
  }

  setLoader = (loading) => {
    if (loading) this.props.onProcessBegin();
    else this.props.onProcessEnd();
  };

  getCompetencyAndInterviewResults = () => {
    this.props.onProcessBegin();
    api
      .get(`/api/employee-360/competency-and-interview-results`)
      .then((response) => {
        this.setState({
          results: response.data.data.results,
          filteredData: response.data.data.results,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.props.onProcessEnd();
      });
  };

  handlePageChange = (pageNum) => {
    this.setState({ activePage: pageNum });
  };

  handleFilter = (e) => {
    this.setState({ filterTerm: e.target.value, activePage: 1 });
  };

  renderSearchBar = () => {
    return (
      <div className="col-xs-12 col-sm-12 col-md-3 col-lg-4 tableSearchArea">
        <div className="inner-addon right-addon">
          <span className="iconmford fo-icon-search"></span>
          <input
            type="text"
            name="tableSearch"
            id="tableSearch"
            className="form-control"
            placeholder={i18next.t("10053")}
            onChange={(e) => this.handleFilter(e)}
            value={this.state.filterTerm}
          />
        </div>
      </div>
    );
  };

  renderHeaderToolbar = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginRight: "20px",
          marginLeft: "20px",
        }}
      >
        {this.renderSearchBar()}

        <Pagination
          hideFirstLastPages={true}
          prevPageText={i18next.t(10110)}
          nextPageText={i18next.t(10111)}
          hideDisabled={true}
          hideNavigation={true}
          activePage={this.state.activePage}
          itemsCountPerPage={this.settings.itemsPerPage}
          totalItemsCount={
            this.state.filteredData?.length > 0
              ? this.state.filteredData.length
              : 0
          }
          onChange={(e) => this.handlePageChange(e)}
          itemClass="page-item"
          linkClass="page-link"
        />
      </div>
    );
  };

  renderFooterToolbar = () => {
    return (
      <div className="table-footer-toolbar">
        {/* <button className="export-button" onClick={this.handleExportCSV}>
          <Trans desc="Dışa Aktar">10113</Trans>
        </button> */}
      </div>
    );
  };

  trDocument = "";
  trCreatedOn = "";
  trPosition = "";

  reOrder = (orderBy) => {
    let sort_dir = "asc";
    if (this.state.sort_dir === "asc") sort_dir = "desc";
    this.setState({
      sort_by: orderBy,
      sort_dir: sort_dir,
    });
  };

  setSotingClassNames = () => {
    this.trDocument = "";
    this.trCreatedOn = "";
    this.trPosition = "";

    switch (this.state.sort_by) {
      case "trDocument":
        this.trDocument = `_${this.state.sort_dir}`;
        break;
      case "trCreatedOn":
        this.trCreatedOn = `_${this.state.sort_dir}`;
        break;
      case "trPosition":
        this.trPosition = `_${this.state.sort_dir}`;
        break;
      default:
        this.trDocument = `_${this.state.sort_dir}`;
        break;
    }
  };

  renderData = (start, end) => {
    const sorted = this.state.filteredData.sort((a, b) => {
      switch (this.state.sort_by) {
        case "trDocument":
          return this.state.sort_dir === "desc"
            ? a.document?.name.localeCompare(b.document?.name)
            : b.document?.name.localeCompare(a.document?.name);
        case "trCreatedOn":
          return this.state.sort_dir === "desc"
            ? new Date(a.createdon) - new Date(b.createdon)
            : new Date(b.createdon) - new Date(a.createdon);
        case "trPosition":
          return this.state.sort_dir === "desc"
            ? a.position?.name.localeCompare(b.position?.name)
            : b.position?.name.localeCompare(a.position?.name);
        default:
          return this.state.sort_dir === "desc"
            ? a.document?.name.localeCompare(b.document?.name)
            : b.document?.name.localeCompare(a.document?.name);
      }
    });

    return sorted.slice(start, end).map((result) => {
      return (
        <CompetencyAndInterviewResult
          key={result.id}
          result={result}
          setLoader={(loading) => this.setLoader(loading)}
        />
      );
    });
  };

  renderCopyButton = () => {
    return (
      <button type="button" className="btn btn-sm m-0 p-0">
        <svg
          viewBox="0 0 612 792"
          style={{ padding: "3px 5px", width: "25px", borderRadius: "3px" }}
        >
          <path
            fill="#CECECE"
            d="M183.6,273.6V151.2c0-33.66,27.54-61.2,61.2-61.2h306c33.8,0,61.2,27.4,61.2,61.2v306
c0,33.8-27.4,61.2-61.2,61.2H428.4V640.8c0,33.8-27.4,61.2-61.2,61.2h-306C27.4,702,0,674.6,0,640.8v-306
c0-33.66,27.54-61.2,61.2-61.2H183.6z M244.8,273.6h122.4c33.8,0,61.2,27.4,61.2,61.2v122.4H550.8v-306h-306V273.6z M61.2,334.8v306
h306v-306H61.2z"
          />
        </svg>
      </button>
    );
  };

  render() {
    let start = this.settings.itemsPerPage * (this.state.activePage - 1);
    let end = start + this.settings.itemsPerPage;

    this.setSotingClassNames();

    return (
      <>
        {this.props.spinner}

        <div className="mb-4 ml-2 mr-2">
          <p>
            <Trans>employee360_topdescription_part1</Trans>
            {this.renderCopyButton()}
            <Trans>employee360_topdescription_part2</Trans>
          </p>
          <p>
            <Trans>employee360_topdescription_1</Trans>
          </p>
        </div>

        <div>{this.renderHeaderToolbar()}</div>
        <div
          className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
          id="ayrilanCalisan"
          style={{ display: "block" }}
        >
          <table
            className="table display responsive dataTable no-footer dtr-none collapsed"
            id="dataTablePersonal"
          >
            <thead>
              <tr>
                <th
                  onClick={() => this.reOrder("trDocument")}
                  className={`all sorting${this.trDocument}`}
                >
                  <div className="tableTitle">
                    <Trans>employee360_reporttype</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("trCreatedOn")}
                  className={`all sorting${this.trCreatedOn}`}
                >
                  <div className="tableTitle">
                    <Trans>employee360_date</Trans>
                  </div>
                </th>
                <DesktopBreakpoint>
                  <th
                    onClick={() => this.reOrder("trPosition")}
                    className={`desktop sorting${this.trPosition}`}
                  >
                    <div className="tableTitle">
                      <Trans>employee360_position</Trans>
                    </div>
                  </th>
                  <th>
                    <div className="tableTitle">
                      <Trans>employee360_password</Trans>
                    </div>
                  </th>
                  <th>
                    <div className="tableTitle">
                      <Trans>employee360_download</Trans>
                    </div>
                  </th>
                </DesktopBreakpoint>
              </tr>
            </thead>
            <tbody>{this.renderData(start, end)}</tbody>
          </table>
        </div>
        <div>
          <hr />
          {this.renderFooterToolbar()}
        </div>
      </>
    );
  }
}

export default containsLongRunningProcess(
  requireAuth(CompetencyAndInterviewResults)
);
